import React, { Component } from "react";
import "./dashboard.css";
import {
  Row,
  Card,
  Col,
  Tabs,
  Table,
  Statistic,
  Icon,
  Input,
  DatePicker,
  Skeleton,
  Breadcrumb,
  Radio,
  Alert
} from "antd";
import Chart from "react-google-charts";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as loginActions from "./actions";
import ActivityCard from "./components/activityCard";
import SkillCard from "./components/skillsCard";
import TopHeader from "../../components/topHeader/view";
const queryString = require('query-string');
const { Search } = Input;
const { TabPane } = Tabs;

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    filters: [
      {
        text: "Joe",
        value: "Joe"
      },
      {
        text: "Jim",
        value: "Jim"
      },
      {
        text: "Submenu",
        value: "Submenu",
        children: [
          {
            text: "Green",
            value: "Green"
          },
          {
            text: "Black",
            value: "Black"
          }
        ]
      }
    ],
    // specify the condition of filtering result
    // here is that finding the name started with `value`
    onFilter: (value, record) => record.name.indexOf(value) === 0,
    sorter: (a, b) => a.name.length - b.name.length,
    sortDirections: ["descend"]
  },
  {
    title: "Score",
    dataIndex: "age",
    defaultSortOrder: "descend",
    sorter: (a, b) => a.age - b.age
  },
  {
    title: "Website",
    dataIndex: "address",
    filters: [
      {
        text: "Hackerearth",
        value: "Hackerearth"
      },
      {
        text: "Hackerrank",
        value: "Hackerrank"
      }
    ],
    filterMultiple: false,
    onFilter: (value, record) => record.address.indexOf(value) === 0,
    sorter: (a, b) => a.address.length - b.address.length,
    sortDirections: ["descend", "ascend"]
  }
];

// const data = [];

const { RangePicker } = DatePicker;
class toppComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:true,
      campusName: null,
      category:"Student",
    };
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  componentDidMount() {
    
  }

  componentWillMount() {
    
    var parsed = queryString.parse(this.props.location.search);
    
    
    if( this.props.match &&
      this.props.match.params &&
      this.props.match.params.campusName &&
      this.props.match.params.campusName.length > 0)
      {
      if(parsed && parsed.Category&& parsed.Category.length>0 && (parsed.Category=="Student" || parsed.Category=="Faculty")){
        this.props.loadCampusDashboardData(this.props.match.params.campusName,parsed.Category);
        this.setState({ campusName: this.props.match.params.campusName,category:parsed.Category, loading:false });
      }
      else{
        this.props.loadCampusDashboardData(this.props.match.params.campusName,"Student");
        this.setState({ campusName: this.props.match.params.campusName,category:"Student",loading:false });
      }
      }
      else {
        
        this.props.loadCampusDashboardData("ADMIN","Student");
        this.setState({ campusName: "ADMIN",category:"Student",loading:false });
      }
  }

  render() {
    const data =  this.props.campusDashboardData && this.props.campusDashboardData.data
      ? this.props.campusDashboardData.data
      : {};
    const profile = this.props.profile
    const campusName = this.props.match.params.campusName
    console.log("DAADA",data)
   if(this.props.campusDashboardData && this.props.campusDashboardData.data) {
    return (
      
      <div>
         {campusName == "ADMIN" ? (
          <TopHeader title={"Vedic.dev"} />
        ) : (
          <TopHeader
            title={campusName + " Dashboard"}
          />
        )}

<Row type="flex" justify="center"  >
  <Col xs={20} sm={20} md={8} lg={8} xl={8} style={{textAlign:'center', background:'white',marginTop:'-21px',borderRadius:'0.5rem', boxShadow:'0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)'}}>
  {this.state.category && this.state.category=="Student" ? 
  <>
  <Link  to={"/home/campusDashboard/"+campusName+"?Category=Student"}><Col id="topHeaderHighlightleft" span={12} style={{padding:12,color:'#6025C0',cursor:'pointer',boxShadow:'inset 0 11px 47px 0 rgba(0, 0, 0, 0.15)',background:'rgb(236, 234, 234)',borderTopLeftRadius:'0.5rem',borderBottomLeftRadius:'0.5rem',fontWeight:500}} >Students</Col></Link>
  <Link to={"/home/campusDashboard/"+campusName+"?Category=Faculty"}><Col id="topHeaderHighlightright" span={12} style={{padding:12,color:'#000000', borderTopRightRadius:'0.5rem',cursor:'pointer',borderBottomRightRadius:'0.5rem',fontWeight:500}}>Faculty</Col></Link>
  </> : <>
  <Link  to={"/home/campusDashboard/"+campusName+"?Category=Student"}><Col id="topHeaderHighlightright" span={12} style={{padding:12,color:'#000000',cursor:'pointer',borderTopLeftRadius:'0.5rem',borderBottomLeftRadius:'0.5rem',fontWeight:500}} >Students</Col></Link>
  <Link to={"/home/campusDashboard/"+campusName+"?Category=Faculty"}><Col id="topHeaderHighlightleft" span={12} style={{padding:12,color:'#6025C0', borderTopRightRadius:'0.5rem',cursor:'pointer',borderBottomRightRadius:'0.5rem',fontWeight:500,background:'rgb(236, 234, 234)'}}>Faculty</Col></Link>
  </>}
  
  </Col>
  </Row>

        <Row  gutter={16} style={{ padding: 25 }}>
  
        <Breadcrumb style={{paddingLeft:10}}>
    <Breadcrumb.Item> <Link to={"/home/campusDashboard/ADMIN?Category="+(this.state.category && this.state.category)}>Society Dashboard</Link> </Breadcrumb.Item>
    <Breadcrumb.Item>
    <Link to={"/home/campusDashboard/"+campusName+"?Category="+(this.state.category && this.state.category)}> {(campusName).toUpperCase()}</Link>
   
    </Breadcrumb.Item>

    </Breadcrumb>
          <h1 style={{ padding: 10 }}>{this.state.category && this.state.category} dashboard</h1>
          <ActivityCard
            cardStyle={{
              className: "dashboardCard",
              title: "Registered "+(this.state.category && this.state.category),
              bordered: true,
              bodyStyle: {
                background: "#54d2cc"
              },
              headStyle: {
                background: "rgb(28, 241, 230)"
              },
              actions: [
                <>
                  {" "}
                  {this.state.category && this.state.category=="Student" ?  <Link to={"/home/studentsList?Category="+(this.state.category && this.state.category)+(campusName=='ADMIN' ? "" : "&Campus="+campusName)}> View List </Link> :  <Link to={"/home/facultyList?Category="+(this.state.category && this.state.category)+(campusName=='ADMIN' ? "" : "&Campus="+campusName)}> View List </Link> }
                 
                </>
              ]
            }}
            statisticColData={[
              [
                "No. of Registered "+(this.state.category && this.state.category),
                data.noOfRegistredStudents ? data.noOfRegistredStudents : "NA",
                <Icon
                  type="caret-up"
                  theme="filled"
                  style={{ color: "#3f8600" }}
                />,
                "/100"
              ]
            ]}
          />

          {/* <ActivityCard
            cardStyle={{
              className: "dashboardCard",
              title: "Registered Faculty/HoD",
              bordered: true,
              bodyStyle: {
                background: "#54d2cc"
              },
              headStyle: {
                background: "rgb(28, 241, 230)"
              },
              actions: [
                <>
                  {" "}
                  <Link to={"/home/facultyList"+(campusName=='ADMIN' ? "" : "?Campus="+campusName)}> View faculty dashboard </Link>
                </>
              ]
            }}
            statisticColData={[
              [
                "No. of Registered Faculty",
                data.noOfRegistredFaculty ? data.noOfRegistredFaculty : "NA",
                <Icon type="usergroup-add" />,
                "/100"
              ]
            ]}
          /> */}

          <ActivityCard
            cardStyle={{
              className: "dashboardCard",
              title: "Skills",
              bordered: true,
              bodyStyle: {
                background: "#54d2cc"
              },
              headStyle: {
                background: "rgb(28, 241, 230)"
              },
              actions: [
                <>
                  {" "}
                  <Link to={"/home/skills?Category="+(this.state.category && this.state.category)+(campusName=='ADMIN' ? "" : "&Campus="+campusName)}> View skill dashboard </Link>
                </>
              ]
            }}
            statisticColData={[
              [
                (this.state.category && this.state.category)+" with skills",
                data.noOfStudentWithSkills ? data.noOfStudentWithSkills : "NA",
                <Icon type="bulb" />,
                "/100"
              ]
            ]}
          />

          <ActivityCard
            cardStyle={{
              className: "dashboardCard",
              title: "Projects",
              bordered: true,
              bodyStyle: {
                background: "#54d2cc"
              },
              headStyle: {
                background: "rgb(28, 241, 230)"
              },
              actions: [
                <>
                  {" "}
                  <Link to={"/home/projectsDashboard?Category="+(this.state.category && this.state.category)+(campusName=='ADMIN' ? "" : "&Campus="+campusName)}> View project dashboard </Link>
                </>
              ]
            }}
            statisticColData={[
              [
                "Total",
                data.noOfProjectsByStudents
                  ? data.noOfProjectsByStudents.total
                  : "NA",
                <Icon type="codepen" />,
                "/100"
              ],
              [
                "Completed",
                data.noOfProjectsByStudents
                  ? data.noOfProjectsByStudents.completed
                  : "NA",
                <Icon type="code-sandbox" />,
                "/100"
              ]
            ]}
          />

          <ActivityCard
            cardStyle={{
              className: "dashboardCard",
              title: "Workshops",
              bordered: true,
              bodyStyle: {
                background: "#54d2cc"
              },
              headStyle: {
                background: "rgb(28, 241, 230)"
              },
              actions: [
                <>
                  {" "}
                  <Link to={"/home/workshops?Category="+(this.state.category && this.state.category)+(campusName=='ADMIN' ? "" : "&Campus="+campusName)}> View workshop dashboard </Link>
                </>
              ]
            }}
            statisticColData={[
              [
                (this.state.category && this.state.category)+" with workshops",
                data.noOfStudentAttendedWorkshops
                  ? data.noOfStudentAttendedWorkshops
                  : "NA",
                <Icon type="code" />,
                "/100"
              ]
            ]}
          />

          <ActivityCard
            cardStyle={{
              className: "dashboardCard",
              title: "Internships",
              bordered: true,
              bodyStyle: {
                background: "#54d2cc"
              },
              headStyle: {
                background: "rgb(28, 241, 230)"
              },
              actions: [
                <>
                  {" "}
                  <Link to={"/home/internships?Category="+(this.state.category && this.state.category)+(campusName=='ADMIN' ? "" : "&Campus="+campusName)}>
                    {" "}
                    View internship dashboard{" "}
                  </Link>
                </>
              ]
            }}
            statisticColData={[
              [
                (this.state.category && this.state.category)+" with internship",
                data.noOfStudentWithInternships
                  ? data.noOfStudentWithInternships
                  : "NA",
                <Icon type="api" />,
                "/100"
              ]
            ]}
          />

          <ActivityCard
            cardStyle={{
              className: "dashboardCard",
              title: "Conferences",
              bordered: true,
              bodyStyle: {
                background: "#54d2cc"
              },
              headStyle: {
                background: "rgb(28, 241, 230)"
              },
              actions: [
                <>
                  {" "}
                  <Link to={"/home/conferences?Category="+(this.state.category && this.state.category)+(campusName=='ADMIN' ? "" : "&Campus="+campusName)}>
                    {" "}
                    View conference dashboard{" "}
                  </Link>
                </>
              ]
            }}
            statisticColData={[
              [
                "No of "+(this.state.category && this.state.category),
                data.noOfStudentAttendedConferenses
                  ? data.noOfStudentAttendedConferenses
                  : "NA",
                <Icon type="contacts" />,
                "/100"
              ]
            ]}
          />

          <ActivityCard
            cardStyle={{
              className: "dashboardCard",
              title: "Publications",
              bordered: true,
              bodyStyle: {
                background: "#54d2cc"
              },
              headStyle: {
                background: "rgb(28, 241, 230)"
              },
              actions: [
                <>
                  {" "}
                  <Link to={"/home/publications?Category="+(this.state.category && this.state.category)+(campusName=='ADMIN' ? "" : "&Campus="+campusName)}>
                    {" "}
                    View publication dashboard{" "}
                  </Link>
                </>
              ]
            }}
            statisticColData={[
              [
                "Total",
                data.noOfPublicationsByStudents
                  ? data.noOfPublicationsByStudents.total
                  : "NA",
                <Icon type="read" />,
                "/100"
              ],
              [
                (this.state.category && this.state.category),
                data.noOfPublicationsByStudents
                  ? data.noOfPublicationsByStudents.students
                  : "NA",
                <Icon type="user" />,
                "/100"
              ]
            ]}
          />

          <ActivityCard
            cardStyle={{
              className: "dashboardCard",
              title: "Certification",
              bordered: true,
              bodyStyle: {
                background: "#54d2cc"
              },
              headStyle: {
                background: "rgb(28, 241, 230)"
              },
              actions: [
                <>
                  {" "}
                  <Link to={"/home/certifications?Category="+(this.state.category && this.state.category)+(campusName=='ADMIN' ? "" : "&Campus="+campusName)}>
                    {" "}
                    View certification dashboard{" "}
                  </Link>
                </>
              ]
            }}
            statisticColData={[
              [
                (this.state.category && this.state.category)+" with certification",
                data.noOfStudentWithCertification
                  ? data.noOfStudentWithCertification
                  : "NA",
                <Icon type="book" />,
                "/100"
              ]
            ]}
          />
        </Row>
        {this.props.match.params.campusName == "ADMIN" ? (
          <Row
            gutter={16}
            style={{ paddingLeft: 25, paddingRight: 25, marginBottom: 20 }}
          >
            <h1 style={{ padding: 10, marginTop: 0 }}>Campus dashboard</h1>

            <ActivityCard
              cardStyle={{
                className: "dashboardCard",
                title: "SVECW Dashboard",
                bordered: true,
                bodyStyle: {
                  background: "rgb(255, 206, 247)"
                },
                headStyle: {
                  background: "#A5238F"
                },
                actions: [
                  <>
                    {" "}
                    <Link to={"/home/campusDashboard/SVECW?Category="+(this.state.category && this.state.category)}>
                      {" "}
                      View SVECW Dashboard{" "}
                    </Link>
                  </>
                ]
              }}
              statisticColData={[
                [
                  "Total No. of Registered "+(this.state.category && this.state.category),
                  data.campusesDashboardData
                    ? data.campusesDashboardData.SVECW
                    : "NA",
                  <Icon type="user" />,
                  "/100"
                ]
              ]}
            />

            <ActivityCard
              cardStyle={{
                className: "dashboardCard",
                title: "VIT Dashboard",
                bordered: true,
                bodyStyle: {
                  background: "rgb(255, 193, 140)"
                },
                headStyle: {
                  background: "#F48221"
                },
                actions: [
                  <>
                    {" "}
                    <Link to={"/home/campusDashboard/VIT?Category="+(this.state.category && this.state.category)}>
                      {" "}
                      View VIT Dashboard{" "}
                    </Link>
                  </>
                ]
              }}
              statisticColData={[
                [
                  "Total No. of Registered "+(this.state.category && this.state.category),
                  data.campusesDashboardData
                    ? data.campusesDashboardData.VIT
                    : "NA",
                  <Icon type="user" />,
                  "/100"
                ]
              ]}
            />

            <ActivityCard
              cardStyle={{
                className: "dashboardCard",
                title: "BVRITN Dashboard",
                bordered: true,
                bodyStyle: {
                  background: "rgb(213, 232, 158)"
                },
                headStyle: {
                  background: "#A7CD39"
                },
                actions: [
                  <>
                    {" "}
                    <Link to={"/home/campusDashboard/BVRIT?Category="+(this.state.category && this.state.category)}>
                      {" "}
                      View BVRITN Dashboard{" "}
                    </Link>
                  </>
                ]
              }}
              statisticColData={[
                [
                  "Total No. of Registered "+(this.state.category && this.state.category),
                  data.campusesDashboardData
                    ? data.campusesDashboardData.BVRIT
                    : "NA",
                  <Icon type="user" />,
                  "/100"
                ]
              ]}
            />

            <ActivityCard
              cardStyle={{
                className: "dashboardCard",
                title: "BVRITH Dashboard",
                bordered: true,
                bodyStyle: {
                  background: "rgb(197, 182, 226)"
                },
                headStyle: {
                  background: "rgb(144, 87, 255)"
                },
                actions: [
                  <>
                    {" "}
                    <Link to={"/home/campusDashboard/BVRITH?Category="+(this.state.category && this.state.category)}>
                      {" "}
                      View BVRITH Dashboard{" "}
                    </Link>
                  </>
                ]
              }}
              statisticColData={[
                [
                  "Total No. of Registered "+(this.state.category && this.state.category),
                  data.campusesDashboardData
                    ? data.campusesDashboardData.BVRITH
                    : "NA",
                  <Icon type="user" />,
                  "/100"
                ]
              ]}
            />
          </Row>
        ) : (
          <></>
        )}

        <Row style={{ padding: 25, marginTop: 0, paddingTop: 0 }}>
          <Tabs className="dashboardTabs">
            <TabPane style={{padding:20}} tab="Skills" key="1">
             
              <Row>
                
              <Col xs={24} sm={24} md={0} lg={0} xl={0}> <Alert message="Skill performance graph not available in Mobile Browser. Check in Desktop Browser" type="warning"  />  </Col>
                <Col style={{padding:20}} className="dashboardTabsContent" xs={0} sm={0} md={16} lg={16} xl={16}>
               
             
               
                  <Chart
                    width={"100%"}
                    height={"300px"}
                    chartType="Bar"
                    loader={<div>Loading Chart</div>}
                    data={
                      data.skills
                        ? [
                            ["Technology", "Number Of "+(this.state.category && this.state.category)],
                            ...Object.keys(data.skills).map(el => data.skills[el]&&data.skills[el]>5 && [el,data.skills[el]]).filter(Boolean)
                            // ["C", 1000],
                            // ["C++", 1170],
                            // ["Python", 660],
                            // ["Node", 1030],
                            // ["Android", 1000],
                            // ["SQL", 1170],
                            // ["ML", 660],
                            // ["VLSI", 1030],
                            // ["VR", 1170],
                            // ["JAVA", 660],
                            // ["IoS", 1030]
                          ]
                        : [["Technology", "Number Of "+(this.state.category && this.state.category)]]
                    }
                    options={{
                      // Material design options
                      chart: {
                        title: "Top Skills Performance",
                        subtitle: "Based on technology analysis from: 2017-2019"
                      }
                    }}
                    // For tests
                    rootProps={{ "data-testid": "2" }}
                    chartEvents={[
                      {
                        eventName: "select",
                        callback: ({ chartWrapper }) => {
                          const chart = chartWrapper.getChart();
                          const selection = chart.getSelection();
                          if (selection.length === 1) {
                            const [selectedItem] = selection;
                            const dataTable = chartWrapper.getDataTable();
                            const { row, column } = selectedItem;

                            // alert(
                            //   "You selected : " +
                            //     JSON.stringify({
                            //       row,
                            //       column,
                            //       value: dataTable.getValue(row, 0)
                            //     }),
                            //   null,
                            //   2
                            // );
                            this.props.history.push(
                              `/home/skills/${dataTable.getValue(row, 0)}?Category=${(this.state.category && this.state.category)}${(campusName=='ADMIN' ? "" : "&Campus="+campusName)}`
                            );
                          }
                          
                        }
                      }
                    ]}
                  />
                </Col>
                <Col className="dashboardTabConTwo" xs={0} sm={0} md={8} lg={8} xl={8}>
                  <h4>Top {(this.state.category && this.state.category)} with skills</h4>
                  <Icon style={{color:'red'}} type="clock-circle" /> <span>Not Updated</span>
                  <ul class="antd-pro-pages-dashboard-analysis-style-rankingList">
                    <li>
                      <span class="antd-pro-pages-dashboard-analysis-style-rankingItemNumber antd-pro-pages-dashboard-analysis-style-active whiteC">
                        1
                      </span>
                      <span
                        class="antd-pro-pages-dashboard-analysis-style-rankingItemTitle"
                        title="Gongzhuan No.0 shop"
                      >
                        Yasaswini
                      </span>
                      <span>79.5%</span>
                    </li>
                  </ul>
                  <ul class="antd-pro-pages-dashboard-analysis-style-rankingList">
                    <li>
                      <span class="antd-pro-pages-dashboard-analysis-style-rankingItemNumber antd-pro-pages-dashboard-analysis-style-active whiteC">
                        2
                      </span>
                      <span
                        class="antd-pro-pages-dashboard-analysis-style-rankingItemTitle"
                        title="Gongzhuan No.0 shop"
                      >
                        Movina
                      </span>
                      <span>75%</span>
                    </li>
                  </ul>
                  <ul class="antd-pro-pages-dashboard-analysis-style-rankingList">
                    <li>
                      <span class="antd-pro-pages-dashboard-analysis-style-rankingItemNumber antd-pro-pages-dashboard-analysis-style-active whiteC">
                        3
                      </span>
                      <span
                        class="antd-pro-pages-dashboard-analysis-style-rankingItemTitle"
                        title="Gongzhuan No.0 shop"
                      >
                        Bharath Shetty
                      </span>
                      <span>72%</span>
                    </li>
                  </ul>
                  <ul class="antd-pro-pages-dashboard-analysis-style-rankingList">
                    <li>
                      <span class="antd-pro-pages-dashboard-analysis-style-rankingItemNumber antd-pro-pages-dashboard-analysis-style-active whiteC">
                        4
                      </span>
                      <span
                        class="antd-pro-pages-dashboard-analysis-style-rankingItemTitle"
                        title="Gongzhuan No.0 shop"
                      >
                        Prashanth
                      </span>
                      <span>71.5%</span>
                    </li>
                  </ul>
                  <ul class="antd-pro-pages-dashboard-analysis-style-rankingList">
                    <li>
                      <span class="antd-pro-pages-dashboard-analysis-style-rankingItemNumber antd-pro-pages-dashboard-analysis-style-active whiteC">
                        5
                      </span>
                      <span
                        class="antd-pro-pages-dashboard-analysis-style-rankingItemTitle"
                        title="Gongzhuan No.0 shop"
                      >
                        Suresh
                      </span>
                      <span>69.2%</span>
                    </li>
                  </ul>
                </Col>
              </Row>

              <Row><SkillCard category={this.state.category && this.state.category} campus={campusName && campusName} skills={data.skills ?  data.skills : []}/></Row>

            </TabPane>
            <TabPane tab="Projects" key="2">
              <Col className="dashboardTabsContent" xs={0} sm={0} md={16} lg={16} xl={16}>
                <Chart
                  width={"100%"}
                  height={"300px"}
                  chartType="PieChart"
                  loader={<div>Loading Chart</div>}
                  data={
                    data.projectsCompletionLevel
                      ? [
                          ["Percentage Completed", "Number Of "+(this.state.category && this.state.category)],
                          ...Object.keys(data.projectsCompletionLevel).map(
                            el => [
                              el.replace("Percent", "") + "% Completed",
                              parseInt(data.projectsCompletionLevel[el])
                            ]
                          )
                        ]
                      : [["Technology", "Number Of "+(this.state.category && this.state.category)]]
                  }
                  options={{
                    chart: {
                      title: "Projects Completion Chart"
                    }
                  }}
                  rootProps={{ "data-testid": "2" }}
                />
              </Col>
            </TabPane>
          </Tabs>
        </Row>
        <Row gutter={16} style={{ padding: 25, paddingTop: 0 }}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Card title="Competitive Programming" bordered={false}>
              <Row
                gutter={16}
                style={{ marginRight: 0, marginLeft: 0, marginBottom: 25 }}
              >
                <Col span={12}>
                  <Statistic
                    title="Problems Solved"
                    value={"NA"}
                    prefix={<Icon type="like" />}
                  />
                </Col>
                <Col span={12}>
                  <Statistic title="Activity" value={"NA"} suffix="/ 100" />
                </Col>
              </Row>
              <Table
                rowKey={record => record.index}
                size="small"
                columns={columns}
                dataSource={[]}
                // dataSource={data}
                pagination={{
                  style: {
                    marginBottom: 0
                  },
                  pageSize: 5
                }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Card title="SMART INTERVIEWS CONTEST" bordered={false}>
              <Row
                gutter={16}
                style={{ marginRight: 0, marginLeft: 0, marginBottom: 25 }}
              >
                <Col span={12}>
                  <Statistic
                    title="Participated"
                    value={"NA"}
                    prefix={<Icon type="user" />}
                  />
                </Col>
                <Col span={12}>
                  <Statistic title="Completed" value={"NA"} suffix="/100" />
                </Col>
              </Row>
              <Table
                rowKey={record => record.index}
                size="small"
                columns={columns}
                // dataSource={data}
                dataSource={[]}
                pagination={{
                  style: {
                    marginBottom: 0
                  },
                  pageSize: 5
                }}
              />
            </Card>
          </Col>
        </Row>
    
      </div>
    );
   }  
   else{
     return (
       <>
     {this.props.match.params.campusName == "ADMIN" ? (
      <TopHeader title={"Vedic.dev"} />
    ) : (
      <TopHeader
        title={this.props.match.params.campusName + " Dashboard"}
      />
    )
  }
     <Skeleton loading={true}></Skeleton>
     </>
     )}
    
  }
}

const mapStateToProps = state => {
   
  return {
    profile : state.firebase.profile.isLoaded && state.firebase.profile,
    campusDashboardData: state.auth.campusDashboardData,
  };
};

const mapDispachToProps = (dispatch, props) => ({
  loadCampusDashboardData: (campus,category) => {
    dispatch(loginActions.loadCampusDashboardData(campus,category));
  },
  onUnload: () =>
  dispatch({  type: "HOME_PAGE_UNLOADED" })
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(toppComponent);
